import type { PageContext } from 'vike/types';
import { clampMetaTitle } from '../../utils/seo/clamp-meta-title';
import { AUTHORS_INDEX_SEO, resolveAuthorsSeoLocale } from '../../utils/authors/authors-index-seo';

export default function title(pageContext: PageContext): string {
  return clampMetaTitle(AUTHORS_INDEX_SEO[resolveAuthorsSeoLocale(pageContext)].title);
}
